import { useQuery } from '@tanstack/react-query'
import api from '../services/api'

/** Moduli add-on attivi per il workspace corrente */
export function useActiveModules() {
  const { data, isLoading } = useQuery<string[]>({
    queryKey: ['active-modules'],
    queryFn: async () => {
      const r = await api.get('/modules/active')
      const modules = r.data?.modules || []
      return modules.map((m: { module_key: string }) => m.module_key)
    },
    staleTime: 60_000,
    retry: 1,
  })

  return {
    activeModules: data || [],
    isLoading,
    hasModule: (key: string) => (data || []).includes(key),
  }
}
